
import { defineComponent } from 'vue';
import BottomNavigation from '../layout/BottomNavigation.vue';

const __default__ = defineComponent({
    components: { BottomNavigation },
    props: {
        headerTitle: { type: String, required: true },
        activeValidate: { type: Boolean, required: true },
        withoutBotNav: { type: Boolean, required: false },
        noPaddingTop: { type: Boolean, required: false },
        fixedSize: { type: Boolean, required: false },
        maxWidth: { type: String, required: false, default: '60%' },
        width: { type: String, required: false, default: undefined },
        minWidth: { type: String, required: false, default: undefined },
        height: { type: String, required: false },
        contentMaxHeight: { type: String, required: false, default: '60vh' },
    },
    methods: {
        confirm() {
            this.$emit('confirm');
        },
        cancel() {
            this.$emit('cancel');
        },
    },
    computed: {
        closeIcon() {
            return require('@/assets/img/close-white.svg');
        },
    },
});

import { useCssVars as _useCssVars } from 'vue'
const __injectCSSVars__ = () => {
_useCssVars(_ctx => ({
  "v67d45d4e": (_ctx.maxWidth),
  "v558b92ba": (_ctx.width),
  "v04147dc0": (_ctx.minWidth),
  "v614825be": (_ctx.contentMaxHeight),
  "v4217cab3": (_ctx.height)
}))}
const __setup__ = __default__.setup
__default__.setup = __setup__
  ? (props, ctx) => { __injectCSSVars__();return __setup__(props, ctx) }
  : __injectCSSVars__

export default __default__